import type { MatchedContext, NavContextDef } from "../types";
import { companyContext } from "./company";
import { docsContext } from "./docs";
import { equipmentContext } from "./equipment";
import { meetingNoteContext } from "./meetingNote";
import { personContext } from "./person";
import { projectContext } from "./project";
import { projectGroupContext } from "./projectGroup";
import { studioConfigContext } from "./studioConfig";
import { studioContext } from "./studio";
import { vehicleContext } from "./vehicle";

/** All contexts. More specific patterns come first. */
export const NAV_CONTEXTS: NavContextDef[] = [
  projectGroupContext,
  projectContext,
  personContext,
  companyContext,
  equipmentContext,
  vehicleContext,
  studioConfigContext,
  studioContext,
  meetingNoteContext,
  docsContext,
];

export function matchContext(pathname: string): MatchedContext | null {
  for (const def of NAV_CONTEXTS) {
    const params = def.match(pathname);
    if (params) return { def, params, key: def.key(params) };
  }
  return null;
}
